import React from 'react';
import PropTypes from 'prop-types';
import { CheckIcon } from '@heroicons/react/24/outline';

SuccessPanel.propTypes = {
  heading: PropTypes.node,
  children: PropTypes.node
};

export default function SuccessPanel(props) {
  const {
    heading = 'Thank you!',
    children = "We've received your details. Someone from the CommunityShare team will be in touch with you soon."
  } = props;

  return (
    <div className="flex flex-col items-center justify-center py-14 px-4 gap-4 text-center">
      <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
        <CheckIcon className="w-6 h-6 text-green-600" strokeWidth={2.5} />
      </div>
      <h3 className="text-2xl font-bold text-cs-gray-900">{heading}</h3>
      <p className="text-base leading-normal text-cs-gray-500 max-w-sm">
        {children}
      </p>
    </div>
  );
}
